export default __webpack_public_path__ + "static/media/1026.2dffdf99.png";